import { ENTER, hasModifierKey, SPACE } from '@angular/cdk/keycodes';
import { Component, Host, HostBinding, HostListener, Input } from '@angular/core';
import { cardAnimations } from './card-animations';
import { CardComponent } from './card.component';

@Component({
  selector: 'mars-card-header',
  template: `
    <header
      class="mars-card-header"
      role="button"
      [tabIndex]="getHostTabIndex()"
      [ngClass]="[getExpandedState(), getDisabledState(), getPaddingClass()]"
    >
      <es-icon
        *ngIf="!getIsDisabled()"
        name="arrow-down"
        [@iconRotate]="getExpandedState()"
      ></es-icon>
      <div class="mars-card-header__content">
        <ng-content></ng-content>
      </div>
    </header>
  `,
  styleUrls: ['./card-header.component.scss'],
  animations: [cardAnimations.iconRotation],
})
export class CardHeaderComponent {
  constructor(@Host() private card: CardComponent) {}

  @HostBinding('attr.aria-expanded')
  get ariaExpanded() {
    return this.card.expanded ? 'true' : 'false';
  }

  @HostBinding('attr.aria-controls')
  get ariaControls() {
    return 'card-content';
  }

  @Input() disabled = false;
  getDisabledState() {
    return this.card.disabled ? '' : 'collapsible';
  }

  getIsDisabled() {
    return this.card.disabled;
  }

  @Input() noPadding = false;
  getPaddingClass() {
    return this.noPadding ? 'no-padding' : '';
  }

  @HostListener('click', ['$event'])
  onClick() {
    if (this.card.disabled) {
      return;
    }

    this._toggle();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.card.disabled) {
      return;
    }

    switch (event.keyCode) {
      case SPACE:
      case ENTER: {
        if (!hasModifierKey(event)) {
          this._toggle();
        }
      }
    }
  }

  getHostTabIndex() {
    return this.card.disabled ? null : 0;
  }

  _toggle() {
    if (this.card) {
      this.card.toggle();
    }
  }

  getExpandedState() {
    return this.card.getExpandedState();
  }
}
